module.exports = __webpack_public_path__ + "img/vote-7@2x.918212d0.png";